import React from "react";
import { Route, Switch, useRouteMatch, Redirect } from "react-router-dom";

import { PageLoading } from "components/Layout";

const Reviews = React.lazy(() => import("./views/Reviews"));

export default function OnboardingRoutes() {
  const { path } = useRouteMatch();

  return (
    <React.Suspense fallback={<PageLoading />}>
      <Switch>
        <Route exact path={path}>
          <Reviews />
        </Route>
        <Route path="*">
          <Redirect to={path} />
        </Route>
      </Switch>
    </React.Suspense>
  );
}
